<template>
  <div>
    <TopAppBar
        ref="top_app_bar"
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="true"
    >
    </TopAppBar>

    <TopAppBarDrawer></TopAppBarDrawer>

    <!-- content -->
    <section class="d-flex h-full flex-column">
      <div class="main-wrapper full flex-grow-1 scroll-y">
        <div class="container container--small pdt-50">
          <title-block :titleData="{msg1: '3525', msg2: '3526'}"></title-block>

          <content-card :contentData="{msg1: '3527', msg2: '3528', str: user}"
                        class="mgt-24 "></content-card>
          <content-card
              :contentData="{msg1: '3529', msg2: '3530'}"></content-card>
        </div>

        <div class="mgt-50">
          <div
              class="d-flex align-items-center justify-content-center flex-column"
          >
            <div class="mdc-button btn-sns-sign point-mark telegram social-button">
              <vue-telegram-login
                  :telegram-login="bot"
                  mode="callback"
                  size="large"
                  @callback="telegramCallbackFunction"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import mainApi from "@/api/mainApi.js";
import joinApi from "@/api/joinApi.js";
import memberApi from "@/api/memberApi.js";
import firebase from "firebase";

import {vueTelegramLogin} from "vue-telegram-login";
import {topAppBarMixin} from "../../mixins/topAppBar.js";
import {mapMutations} from "vuex";

import titleBlock from "@/components/popup/components/titleBlock";
import contentCardBlock from "@/components/popup/components/contentCardBlock";
import {storageConstants} from "@/utils/enum/StorageConstants";

export default {
  name: "Telegram",

  data() {
    return {
      bot: localStorage.getItem(storageConstants.telegramBot),
      telegramBotUrl: localStorage.getItem(storageConstants.telegramUrl),
      BRAND_CODE: localStorage.getItem(storageConstants.brandCode),
      user: "",
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      customToken: ""
    };
  },

  components: {
    TopAppBar,
    TopAppBarDrawer,
    vueTelegramLogin,
    'title-block': titleBlock,
    'content-card': contentCardBlock
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.INIT_JOIN_STORE();
    this.fetchData();
  },

  methods: {
    // Store 변이 정의(define store mutation)
    ...mapMutations("join", [
      "SET_SOCIAL_LINK",
      "SET_PUSH_NOTIFICATION",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    fetchData() {
      let responseData;
      mainApi
          .fetMember()
          .then((response) => {
            responseData = response.data.data;
            this.user = responseData.userId;
          })
          .catch((err) => {
            responseData = err.response.data.meta;
            this.$error({content: responseData.errMsg}).then(() => {
            });
          });
    },

    /**
     *
     * @param {object} user 사용자 정보
     */
    telegramCallbackFunction(user) {
      this.$showLoading();

      this.socialFirstName = user.first;
      this.socialLastName = user.last;
      this.socialFullName = user.fullName;
      this.socialEmail = user.id;

      let params = {
        uid: user.id,
        name: "telegram",
        type: "telegram",
        email: "",
      };

      joinApi.customToken(params).then((response) => {
        let responseData = response.data.data;

        firebase
            .auth()
            .signInWithCustomToken(responseData)
            .then(() => {
              firebase
                  .auth()
                  .currentUser.getIdToken(true)
                  .then((idToken) => {
                    this.customToken = idToken;

                    let socialEmailparams = {
                      type: "firebase",
                      token: this.customToken,
                    };

                    joinApi
                        .existsSocial(socialEmailparams)
                        .then((response) => {
                          if (response.data.data) {
                            let params = {
                              title: this.$t("3552"),
                              content: this.$t("3553"),
                              accept: this.$t("3554"),
                            };
                            this.$alert(params)
                                .then(() => {
                                  firebase.auth().signOut();
                                  this.$moveLogin();
                                })
                                .catch(() => {
                                });
                          } else {
                            this.socialToken = this.customToken;
                            this.socialType = "telegram";
                            this.SET_NAME_FIRST(this.socialFirstName);
                            this.SET_NAME_LAST(this.socialLastName);
                            this.SET_NAME_FULL(this.socialFullName);

                            this.SET_SOCIAL_LINK({
                              type: "firebase",
                              name: this.socialType.toUpperCase(),
                              token: this.socialToken,
                              socialType: "telegram",
                              userloginLanguage: this.userloginLanguage,
                            });
                            this.SET_SOCIAL_ID(this.socialEmail);
                            this.SET_LOGINID(this.socialEmail);

                            let pushTokenByRaectNative = localStorage.getItem(
                                "fbToken"
                            );
                            this.SET_PUSH_NOTIFICATION({
                              pushToken: pushTokenByRaectNative
                                  ? pushTokenByRaectNative
                                  : "",
                              pushLanguage: this.userloginLanguage,
                            });

                            let params = this.setParams();
                            memberApi
                                .integrateSocialAccount(params)
                                .then((response) => {
                                  if (response.data.data) {
                                    this.$router.push({
                                      name: "TelegramMessageAuth",
                                    });
                                  }
                                })
                                .catch((error) => {
                                  console.log("getError => error", error);
                                });
                          }
                        })
                        .catch((error) => {
                          console.log("customToken=>error", error);
                        });
                  });
            });
        this.$hideLoading();
      });
    },

    setParams() {
      let params = {
        social: {
          type: "firebase",
          name: "TELEGRAM",
          token: this.socialToken,
        },
      };
      return params;
    },
  }
}
</script>

<style scoped>

</style>
